AppTabs.createTab( {
name: 'matrix',
icon: 'list-alt',
text: 'Matrix',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-matrix',

		readTableName: 	'tblMatrix',
		editTableName: 	'tblMatrix',
		primaryKey: 	'MatrixID',

		canSort:			false,
		paging:				false,

		actionData:			'datatable',
		actionAutofill: 	'datatable_autofill',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'matrixOptions' );
		},

		fields: [
			{
				label: 		'Name',
				columnName: 'Matrix',
				isEditable: true,
				order: 		'asc',
			},
			{
				label: 		'EQUIS',
				columnName: 'Equis',
				isEditable: true,
			},
		],

	} );
}

} );
